import {useDataProvider} from "./base-data.provider";
import {useCallback} from "react";

export function useQuizAssessmentTestDataProvider() {
  const { request, loading } = useDataProvider();

  const listStudentResults = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-test/student-results",
    })
  }, [request]);

  const startTest = useCallback((availabilityId) => {
    return request({
      method: "POST",
      path: "/quiz-assessment-test",
      body: { availabilityId },
    })
  }, [request])

  const removeTest = useCallback((testId) => {
    return request({
      method: "DELETE",
      path: "/quiz-assessment-test/" + testId,
    })
  }, [request])

  const getTestDetails = useCallback((testId) => {
    return request({
      method: "GET",
      path: "/quiz-assessment-test/" + testId,
    })
  }, [request]);

  const getTestAnswerKey = useCallback((testId) => {
    return request({
      method: "GET",
      path: "/quiz-assessment-test/" + testId + '/answer-key',
    })
  }, [request]);

  const getAvailabilityAnswerKey = useCallback((testId) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-test/${testId}/availability-answer-key`,
    })
  }, [request]);

  const saveResults = useCallback((testId, response) => {
    return request({
      method: "PATCH",
      path: "/quiz-assessment-test/save-result",
      body: { testId, response },
    })
  }, [request]);

  const getAverage = useCallback((assessmentType, classId, academicPeriodId) => {
    return request({
      method: "GET",
      path: "/quiz-assessment-test/average",
      query: { assessmentType, classId, academicPeriodId },
    })
  }, [request]);

  const getSummary = useCallback((assessmentType, classId, academicPeriodId) => {
    return request({
      method: "GET",
      path: "/quiz-assessment-test/summary",
      query: { assessmentType, classId, academicPeriodId },
    })
  }, [request]);


  const correctTest = useCallback((testId, userContextId, response) => {
    return request({
      method: "PATCH",
      path: "/quiz-assessment-test/correct-test",
      body: { testId, userContextId, response },
    })
  }, [request]);

  const editTestResponse = useCallback((testId, response) => {
    return request({
      method: "PATCH",
      path: `/quiz-assessment-test/${testId}/response`,
      body: { response },
    })
  }, [request]);

  const printTest = useCallback((availabilityId, userContextId, studentName, testId) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-test-print/download/${testId}`,
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      const formattedStudentName = studentName.replace(/\s+/g, "_").toLowerCase();
      const shortTestId = testId.slice(0, 8);
      link.setAttribute("download", `${formattedStudentName}_${shortTestId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
  }, [request]);

  const printClassTest = useCallback((availabilityId, assessmentName) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-test-print/download/availability/${availabilityId}`,
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      const fileName = (assessmentName || availabilityId).replace(/[\\/:*?"<>|]/g, "").trim();
      link.setAttribute("download", `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    })
  }, [request]);

  const pubPrintTest = useCallback((availabilityId, userContextId) => {
    return request({
      method: "POST",
      path: `/quiz-assessment-test-print/pub/${availabilityId}/${userContextId}`,
    })
  }, [request]);

  const pubPrintClassTest = useCallback((availabilityId) => {
    return request({
      method: "POST",
      path: `/quiz-assessment-test-print/pub/${availabilityId}/class`,
    })
  }, [request]);

  const getTestDocument = useCallback((testId) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-test-print/document/${testId}`,
    })
  }, [request]);

  const getTestDocumentByAvailability = useCallback((availabilityId) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-test-print/document/availability/${availabilityId}`,
    })
  }, [request]);

  const extractAnswersFromImage = useCallback((image) => {
    const formData = new FormData();
    formData.append("image", image);
    return request({
      method: "POST",
      path: "/quiz-assessment-test-print/extract-answers",
      body: formData,
    })
  }, [request]);

  return {
    listStudentResults,
    startTest,
    loading,
    getAverage,
    getSummary,
    getTestAnswerKey,
    getAvailabilityAnswerKey,
    saveResults,
    removeTest,
    getTestDetails,
    printTest,
    correctTest,
    editTestResponse,
    extractAnswersFromImage,
    printClassTest,
    pubPrintTest,
    pubPrintClassTest,
    getTestDocument,
    getTestDocumentByAvailability,
  }
}
